import firebase from "../../firebase";

export default function({ officeId, appointmentLength, countFrom }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "patientTrackingAdmin",
        funcName: "updateVisitSettings",
        data: {
            officeId,
            appointmentLength,
            countFrom
        }
    });
}
